import { render } from "./Home.vue?vue&type=template&id=b1ce65da"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=b1ce65da&lang=css"

import exportComponent from "/Users/mayankmunjal/Desktop/Mayank MS2/major-studio-2-sp24/08-vue-deploy/vue-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__